import React from "react";
import { PlusIcon, MinusIcon, PencilSquareIcon, TrashIcon, SparklesIcon } from "@heroicons/react/24/outline";
import moment from "moment";

const EtReflectionCard = ({
  refItem,
  index,
  showDetail,
  toggleShowDetail,
  handleEdit,
  handleDelete,
  createMarkup,
  mode="full",        // 24 Jan 2026
  showOwner=false,    // 06 Feb 2026
}) => {

    // First Created - 03 Dec 2025
    // Author - Atul Pandey
    // Updated - 24 Jan 2026 - to display content based on mode
    // Updated - 06 Feb 2026 - display username initial for "Everyone tab" based on showOwner flag


  // 1 - Reflection item  
  const {
    reflectionNoteText,
    reflectionDate,
    reflectionUpdateDate,
    parentReflectionId,
    trailId,
    sessionId,
    userMagicMomentId
  } = refItem;

  return (
    <div className="bg-gray-100 p-3 rounded border shadow-sm">

      {/* --- Row 1: expand, index, updated time, magic moment --- */}
      <div className="flex justify-between items-center">

        {/* Left group: expand + index */}
        <div className="flex items-center space-x-2">
          <div
            onClick={() => toggleShowDetail(refItem._id)}
            className="rounded-full h-6 w-6 hover:bg-white flex justify-center items-center cursor-pointer"
          >
            {showDetail[refItem._id] ? (
              <MinusIcon className="h-4 w-4 text-orange-600" />
            ) : (
              <PlusIcon className="h-4 w-4 text-orange-600" />
            )}
          </div>

          <p className="text-xl font-bold text-gray-600">{index + 1}.</p>

          {/* 06 Feb 2026 - Owner (Collective → Everyone) */}
          {showOwner && refItem?.userId?._id && (
            <div className="ml-3 mr-2 flex items-center gap-2 bg-white rounded-full px-2 py-[2px] border">
                <div className="h-5 w-5 rounded-full bg-orange-100 flex items-center justify-center text-[10px] font-bold text-orange-700">
                {(refItem.userId.name || refItem.userId.username || "U")[0]}
                </div>
                <p className="text-[10px] font-semibold text-gray-700">
                {(refItem.userId.name || refItem.userId.username || "User").split(" ")[0]}
                </p>
            </div>
           )}

          {/* Time since update */}
          <div>
            <p className="text-[9px] mx-1 rounded-full px-2 py-[1px] bg-lime-200">
              {moment(reflectionUpdateDate).fromNow()}
            </p>
            <p className="text-[7px] italic text-gray-400">last updated</p>
          </div>

          {/* --- First Line Preview (collapsed view) --- */}
             {/* 24 Jan 2026 - added mode */}
            {mode === "full" && (
            <div
                className="ml-4 text-[11px] text-gray-700 truncate max-w-[450px] line-clamp-1"
                dangerouslySetInnerHTML={createMarkup(reflectionNoteText)}
            ></div>
            )}

            {mode !== "full" && (
            <div
                className="ml-4 text-[11px] text-gray-700 truncate max-w-[450px] line-clamp-1"
                
            >
              <p className="text-orange-600 text-xs">
                Shared privately 
              </p>
            </div>
            )}
            
        </div>

        {/* Right group: magic moment badge + edit/delete */}
        <div className="flex items-center space-x-2">

          {userMagicMomentId && (
            <div className="flex items-center space-x-1 bg-yellow-200 px-2 py-[2px] rounded-full shadow">
              <SparklesIcon className="h-4 w-4 text-yellow-700" />
              <span className="text-[9px] text-yellow-800">Magic Moment</span>
            </div>
          )}

            {/* 24 Jan 2026 - added mode */}
           {mode === "full" && (
            <PencilSquareIcon
              className="h-5 w-5 text-orange-600 cursor-pointer"
              onClick={() => handleEdit(refItem)}
            />)}

          {/* 24 Jan 2026 - added mode */}
          {!userMagicMomentId && mode === "full" && (
            <TrashIcon
              className="h-5 w-5 text-orange-600 cursor-pointer"
              onClick={() => handleDelete(refItem)}
            />
          )}
        </div>
      </div>

      

      {/* --- Row 3: Expanded full text --- */}
      {showDetail[refItem._id] && mode === "full" && (
        <div
          className="mt-3 p-2 rounded bg-white text-[11px] text-gray-700 fix-nested-lists"
          dangerouslySetInnerHTML={createMarkup(reflectionNoteText)}
        ></div>
      )}

      {showDetail[refItem._id] && mode !== "full" && (
        <div
          className="mt-3 p-2 rounded bg-white text-[11px] text-gray-700 fix-nested-lists"
          
        >
          <p className="text-orange-600 text-xs">
                Reflection has been kept private by the user 
              </p>

        </div>
      )}

      {/* --- Row 4: Metadata (created, week, trail, session) --- */}
      <div className="flex flex-wrap items-center mt-3 text-[10px] text-gray-800 space-x-4 bg-orange-50 m-1 p-2 rounded">

        <div className="flex items-center">
          <span className="font-poppins font-bold">Created:</span>
          <span className="ml-1">{moment(reflectionDate).format("DD MMM YYYY, hh:mm A")}</span>
        </div>

        {parentReflectionId?.weekStarting && (
          <div>
            <span className="font-poppins font-bold">Week:</span>
            <span className="ml-1">
              {moment(parentReflectionId.weekStarting).format("DD MMM")} →{" "}
              {moment(parentReflectionId.weekEnding).format("DD MMM")}
            </span>
          </div>
        )}

        {trailId && (
          <div>
            <span className="font-medium">Trail:</span>
            <span className="ml-1">{trailId.trailName}</span>
          </div>
        )}

        {sessionId && (
          <div>
            <span className="font-medium">Session:</span>
            <span className="ml-1">{sessionId.sessionName}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EtReflectionCard;